const attrs = {
  forbidden_chars: "",
};

const options = {
  type: "admins",
  pathName: "admins",
};

const getters = {
  superAdmin(state) {
    return state;
  },
};

const actions = {
  open: async ({ dispatch }) => {
    const payload = { type: "admins" };
    await dispatch("fetchResources", payload, { root: true });
  },
};

export default {
  generic: {
    attrs,
    options,
  },
  getters,
  actions,
};
